import { render, staticRenderFns } from "./FormAplicados.vue?vue&type=template&id=b2b3c964&"
import script from "./FormAplicados.vue?vue&type=script&lang=js&"
export * from "./FormAplicados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports